// extracted by mini-css-extract-plugin
module.exports = {"copy_button":"CopyButton_copy_button__WOdkY"};